import { DownloadPrescriptionFileParams } from "@interfaces/prescriptions";
import { prescriptionService } from "@services/prescription-service";
import { useMutation } from "react-query";

export const useDownloadPrescriptionFileMutation = () => {
  return useMutation((data: DownloadPrescriptionFileParams) =>
    prescriptionService.downloadFile(data)
  );
};
